import { useMe } from "./useMe";

// Flag isAccounting servido por GET /api/me. El backend ya hace la unión con
// los admins (policy "Accounting"), así que aquí no hay lógica de listas.
export function useIsAccounting(): { isAccounting: boolean; isLoading: boolean } {
  const { data, isPending } = useMe();
  return { isAccounting: data?.isAccounting ?? false, isLoading: isPending };
}
